import { Component } from "react"
import PropTypes from "prop-types"
import { get } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import { numberFormatter } from "helpers/formatters/numbers"
import ContributorsOptions from "components/contributors-options"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import ContributorsTableHead from "components/contributors-table-head"
import { VIEW_TYPES } from "helpers/base"
import "./style.scss"

class ContributorsDetails extends Component {
  static propTypes = {
    selected: PropTypes.object.isRequired,
    selectedValue: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    viewType: PropTypes.string.isRequired,
    order: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    sort: PropTypes.func.isRequired,
    openSecurityProfile: PropTypes.func.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
    openCompositeSecurity: PropTypes.func.isRequired,
    selectedGroup: PropTypes.object,
    selectedGroupSiblings: PropTypes.array,
    showGroup: PropTypes.func.isRequired,
    hideGroup: PropTypes.func.isRequired,
    setContributorsGrouping: PropTypes.func.isRequired,
    contributorsGrouping: PropTypes.object,
    groupedData: PropTypes.array.isRequired,
    availableRollups: PropTypes.array.isRequired,
    contributorsSummaryText: PropTypes.string.isRequired,
    csvData: PropTypes.object.isRequired,
    selectedOption: PropTypes.object.isRequired,
    selectedGroupValue: PropTypes.number,
    showNotHeld: PropTypes.bool.isRequired,
    toggleShowNotHeld: PropTypes.func.isRequired,
    groupBy: PropTypes.string,
    details: PropTypes.array.isRequired,
    show: PropTypes.func.isRequired,
    groupOrder: PropTypes.object.isRequired,
    groupsDropdownColumns: PropTypes.array,
    formatter: PropTypes.func,
  }

  render() {
    const {
      viewType,
      selectedValue,
      selected,
      hide,
      data,
      openSecurityProfile,
      openCompositeSecurity,
      selectedGroup,
      selectedGroupSiblings,
      showGroup,
      hideGroup,
      setContributorsGrouping,
      contributorsGrouping,
      groupedData,
      openFactorProfile,
      sort,
      order,
      availableRollups,
      contributorsSummaryText,
      csvData,
      selectedOption,
      selectedGroupValue,
      showNotHeld,
      toggleShowNotHeld,
      groupBy,
      details,
      show,
      groupOrder,
      groupsDropdownColumns,
      formatter,
    } = this.props
    const showNotHeldToggle = viewType === VIEW_TYPES.ACTIVE ? toggleShowNotHeld : null
    const onBackClick = selectedGroup ? hideGroup : hide

    const selectedOptionColor = get(selectedOption, "color")
    return <div className="contributors-details-wrapper">
      <ContributorsOptions
        contributorsSummaryText={contributorsSummaryText}
        availableRollups={availableRollups}
        setGrouping={setContributorsGrouping}
        currentGrouping={contributorsGrouping}
        selectedGroup={selectedGroup}
        csvData={csvData}
        showNotHeld={showNotHeld}
        toggleShowNotHeld={showNotHeldToggle}
        groupBy={groupBy}
      />
      <Table className="contributors-details-table">
        <TableHead>
          <TableRow>
            <th colSpan={3} className="fake-contribution-select-wrapper" title="% Contribution">
              <div className="contribution-select">Contribution (Net)</div>
            </th>
          </TableRow>
          <TableRow className="sorting-row">
            <ContributorsSorting label="Name" id="name" order={order} sort={sort} />
            <ContributorsSorting
              align="right"
              infoText="Shows each modeled asset's share of the equity value used in model-based calculations."
              label={viewType === VIEW_TYPES.ABSOLUTE ? "Modeled % Equity" : "Modeled Active % Equity"}
              id="equity"
              order={order}
              sort={sort}
            />
            <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"} id="viewType" order={order} sort={sort} />
          </TableRow>
          <TableRow>
            <ContributorsTableHead
              label={selectedGroup ? selectedGroup.name : selected.label}
              color={selectedOptionColor}
              onBackClick={onBackClick}
              dropdownColumns={groupsDropdownColumns}
              dropdownItems={selectedGroup ? selectedGroupSiblings : sortData(details, groupOrder)}
              onDropdownItemClick={(item) => selectedGroup ? showGroup(item) : show(item)}
              selectedItemId={selectedGroup ? selectedGroup.id : selected.id}
              formatter={formatter}
            />
            <TableCell align="right" style={{ color: selectedOptionColor }}>{selectedGroup ? numberFormatter(selectedGroup.totalPercentEquity * 100) : "-"}</TableCell>
            <TableCell align="right" style={{ color: selectedOptionColor }}>{(formatter || numberFormatter)(selectedGroup ? selectedGroupValue : selectedValue) || "-"}</TableCell>
          </TableRow>
        </TableHead>
        <ContributorsTableContent
          selected={selected}
          openSecurityProfile={openSecurityProfile}
          openFactorProfile={openFactorProfile}
          openCompositeSecurity={openCompositeSecurity}
          data={data}
          noPercent
          contributorsGrouping={contributorsGrouping}
          selectedGroup={selectedGroup}
          showGroup={showGroup}
          groupedData={groupedData}
          formatter={formatter}
        />
      </Table>
    </div>
  }
}

export default ContributorsDetails
